module.exports = __webpack_public_path__ + "img/downloadNowar.4eeb7bdc.png";